import { render, staticRenderFns } from "./copy_editor.vue?vue&type=template&id=a8c904ee&scoped=true"
import script from "./copy_editor.vue?vue&type=script&lang=js"
export * from "./copy_editor.vue?vue&type=script&lang=js"
import style0 from "./copy_editor.vue?vue&type=style&index=0&id=a8c904ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c904ee",
  null
  
)

export default component.exports